import Link from "next/link"

import { footerNav } from "@/data/navigation"
import { siteConfig } from "@/data/site"

import { Container } from "./container"

const quickLinks = [
  { title: "Каталог рецептів", href: "/recipes" },
  { title: "Добірки рецептів", href: "/collections" },
  { title: "Сезонні хаби", href: "/seasonal" },
  { title: "Калькулятори", href: "/calculators" },
  { title: "Підбір за інгредієнтами", href: "/ingredient-finder" },
  { title: "Блог і пояснення", href: "/blog" },
]

export function SiteFooter() {
  const year = new Date().getFullYear()

  return (
    <footer className="border-t border-neutral-200 bg-neutral-50">
      <Container className="py-12">
        <div className="grid gap-10 lg:grid-cols-[1.2fr_repeat(3,1fr)]">
          <div className="max-w-md">
            <div className="mb-3 flex items-center gap-3">
              <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-emerald-100 text-lg shadow-sm">
                🐈
              </div>

              <div>
                <div className="text-base font-semibold tracking-tight text-neutral-950">
                  {siteConfig.name}
                </div>
                <div className="text-sm text-neutral-500">
                  {siteConfig.mascot.name} — {siteConfig.mascot.role}
                </div>
              </div>
            </div>

            <p className="text-sm leading-7 text-neutral-600">
              {siteConfig.name} — сучасний портал про домашні заготовки,
              консервацію, ферментацію та сезонну кухню. Тут зібрані перевірені
              рецепти, корисні поради й зручні інструменти для тих, хто любить
              готувати вдома впевнено та з задоволенням.
            </p>

            <p className="mt-4 text-sm leading-7 text-neutral-600">
              Від перших банок огірків до улюбленого варення чи квашених овочів
              — {siteConfig.name} допомагає зберігати смаки сезону просто,
              зрозуміло і без зайвої метушні.
            </p>

            <div className="mt-6 flex flex-wrap gap-2">
              {quickLinks.map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  className="inline-flex rounded-full border border-neutral-200 bg-white px-3 py-1.5 text-xs font-medium text-neutral-700 transition-colors hover:border-emerald-200 hover:bg-emerald-50 hover:text-neutral-950"
                >
                  {item.title}
                </Link>
              ))}
            </div>

            <div className="mt-6 text-sm leading-7 text-neutral-600">
              <div>
                Email:{" "}
                <a
                  href={`mailto:${siteConfig.social.email}`}
                  className="font-medium text-neutral-900 transition-colors hover:text-emerald-700"
                >
                  {siteConfig.social.email}
                </a>
              </div>
            </div>
          </div>

          {footerNav.map((group) => (
            <div key={group.title}>
              <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-neutral-900">
                {group.title}
              </h2>

              <ul className="space-y-2.5">
                {group.items.map((item) => (
                  <li key={item.href}>
                    <Link
                      href={item.href}
                      className="text-sm leading-6 text-neutral-600 transition-colors hover:text-neutral-950"
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-neutral-200 pt-6 text-sm text-neutral-500 lg:flex-row lg:items-center lg:justify-between">
          <p>
            © {year} {siteConfig.name}. Усі права захищені.
          </p>

          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <Link
              href={siteConfig.legal.privacyPath}
              className="transition-colors hover:text-neutral-800"
            >
              Політика конфіденційності
            </Link>
            <Link
              href={siteConfig.legal.termsPath}
              className="transition-colors hover:text-neutral-800"
            >
              Умови користування
            </Link>
            <Link
              href="/contact"
              className="transition-colors hover:text-neutral-800"
            >
              Контакти
            </Link>
            <Link
              href="/faq"
              className="transition-colors hover:text-neutral-800"
            >
              FAQ
            </Link>
          </div>
        </div>
      </Container>
    </footer>
  )
}